// consts
import { WORK_SHIFTS } from 'app/config/work_shifts';

function translateWorkShift(workShift) {
  if (WORK_SHIFTS.MORNING === workShift) {
    return 'Manhã';
  } else if (WORK_SHIFTS.AFTERNOON === workShift) {
    return 'Tarde';
  } else if (WORK_SHIFTS.NIGHT === workShift) {
    return 'Noite';
  } else {
    return '--';
  }
}

export { translateWorkShift };
